import TrainInfo from './Train'
export default TrainInfo


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TrainInfo/index.tsx